const normalize = (value?: string | null): string | undefined => {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export type PublicBlogScope = {
  organizationId?: string;
  organizationSlug?: string;
  cacheKey: string;
};

/**
 * Resolves deterministic public-blog scope for both client and server code.
 * This prevents hostname/proxy differences from returning different article sets.
 */
export const resolvePublicBlogScope = (): PublicBlogScope => {
  const organizationId =
    normalize(process.env.NEXT_PUBLIC_PUBLIC_BLOG_ORGANIZATION_ID) ??
    normalize(process.env.PUBLIC_DEFAULT_ORGANIZATION_ID);
  const organizationSlug =
    normalize(process.env.NEXT_PUBLIC_PUBLIC_BLOG_ORGANIZATION_SLUG) ??
    normalize(process.env.PUBLIC_DEFAULT_ORGANIZATION_SLUG);

  return {
    organizationId,
    organizationSlug,
    cacheKey: `org:${organizationId ?? ""}|slug:${organizationSlug ?? ""}`,
  };
};
